<template>
  <div class="properties-form">
    <div class="properties-form-item">
      <div class="label">名称</div>
      <div class="form-item">
        <a-input
          v-model:value="elementName"
          @pressEnter="setElementName"
          @blur="setElementName"
        />
      </div>
    </div>
    <div class="properties-form-block"></div>
    <div
      v-for="(item, itemIndex) in inPortData"
      :key="itemIndex"
      class="properties-form-item"
    >
      <div class="label">输入{{ itemIndex + 1 }}</div>
      <div class="form-item in-port-form-item">
        <a-select
          v-model:value="inPortData[itemIndex]['sourcePortId']"
          @change="(portId) => changeInPortConnect(portId, item, itemIndex)"
        >
          <a-select-option
            v-for="canConnectInPort in canConnectOutPortsList"
            :key="canConnectInPort.portId"
            :value="canConnectInPort.portId"
          >
            {{ canConnectInPort.name }}</a-select-option
          >
        </a-select>
        <a-tooltip
          v-if="inPortData[itemIndex]['sourcePortId']"
          placement="bottom"
        >
          <template #title>删除连线</template>
          <ApiOutlined @click="removeInPortLink(itemIndex)" />
        </a-tooltip>
        <!-- <a-tooltip v-if="inPortData.length > 2" placement="bottom">
          <template #title>删除节点</template>
          <MinusCircleOutlined @click="removeInPortInfo(itemIndex)" />
        </a-tooltip> -->
      </div>
    </div>
    <!-- <div class="in-port-form-btn-item">
      <a-button type="primary" @click="addInData">添加输入</a-button>
    </div> -->
    <div class="properties-form-block"></div>
    <div
      v-for="(item, itemIndex) in outPortData"
      :key="itemIndex"
      class="properties-form-item"
    >
      <div class="label">输出{{ itemIndex + 1 }}</div>
      <div class="form-item out-port-form-item">
        <a-select
          v-model:value="outPortData[itemIndex]['targetPortId']"
          @change="(portId) => changeOutPortConnect(portId, item, itemIndex)"
        >
          <a-select-option
            v-for="canConnectInPort in canConnectInPortsList"
            :key="canConnectInPort.portId"
            :value="canConnectInPort.portId"
          >
            {{ canConnectInPort.name }}
          </a-select-option>
        </a-select>
        <a-tooltip v-if="outPortData.length > 1" placement="bottom">
          <template #title>删除节点</template>
          <MinusCircleOutlined @click="removeOutPortInfo(itemIndex)" />
        </a-tooltip>
      </div>
    </div>
    <div class="out-port-form-btn-item">
      <a-button type="danger" @click="addOutData">添加输出</a-button>
    </div>
  </div>
</template>

<script>
import * as R from "ramda";
import { defineComponent } from "vue";
import { MinusCircleOutlined, ApiOutlined } from "@ant-design/icons-vue";

export default defineComponent({
  components: {
    MinusCircleOutlined,
    ApiOutlined,
  },
  props: {
    elementView: Object,
    elementDataName: String,
    elementDataStateData: Object,
    elementDataMethods: Object,
  },
  data() {
    return {
      elementName: "",
      elementFormValues: {},

      inPortData: [],
      preInPortData: [],

      outPortData: [],
      preOutPortData: [],

      canConnectInPortsList: [],
      canConnectOutPortsList: [],
    };
  },
  mounted() {
    this.init();
    this.initPropertiesFormListener();
  },
  methods: {
    init() {
      this.elementName = this.elementDataName;
      this.getInData();
      this.getOutData();
      this.getCanConnectInPortsList();
      this.getCanConnectOutPortsList();
    },
    initPropertiesFormListener() {
      this.elementDataMethods.addPropertiesFormListener(() => {
        console.log("initPropertiesFormListener");
        this.init();
      });
    },
    setElementName() {
      this.elementDataMethods.setElementName(this.elementName);
    },
    addInPort() {
      this.elementDataMethods.addInPort();
    },
    getInData() {
      const inData = this.elementDataMethods.getInData();
      this.inPortData = R.clone(inData);
      this.preInPortData = R.clone(inData);
    },
    getOutData() {
      const outData = this.elementDataMethods.getOutData();
      this.outPortData = R.clone(outData);
      this.preOutPortData = R.clone(outData);
    },
    getCanConnectOutPortsList() {
      const canConnectOutPortsList =
        this.elementDataMethods.getCanConnectOutPortsList();
      this.canConnectOutPortsList = canConnectOutPortsList;
    },
    getCanConnectInPortsList() {
      const canConnectInPortsList =
        this.elementDataMethods.getCanConnectInPortsList();
      this.canConnectInPortsList = canConnectInPortsList;
    },
    changeInPortConnect(portId, inPortInfoItem, index) {
      const {
        canConnectOutPortsList,
        elementDataMethods,
        inPortData,
        preInPortData,
      } = this;

      let isOtherPortConnected = false;
      let conncetedInPortInfoItem = null;
      let conncetedInPortInfoItemIndex = null;

      for (let i = 0; i < preInPortData.length; i++) {
        let tmpInPortInfoItem = preInPortData[i];
        if (tmpInPortInfoItem.sourcePortId === portId) {
          isOtherPortConnected = true;
          conncetedInPortInfoItem = tmpInPortInfoItem;
          conncetedInPortInfoItemIndex = i;
          break;
        }
      }

      if (isOtherPortConnected) {
        console.log("isOtherPortConnected", isOtherPortConnected);

        elementDataMethods.swapInPortsLink(
          preInPortData[index],
          conncetedInPortInfoItem
        );
        const preInPortDataClone = R.clone(preInPortData);
        const conncetedInPortInfoItemClone = R.clone(conncetedInPortInfoItem);

        ["sourcePortId", "sourceCellId", "linkId"].map((key) => {
          preInPortDataClone[index][key] = conncetedInPortInfoItemClone[key];
          preInPortDataClone[conncetedInPortInfoItemIndex][key] =
            preInPortData[index][key];
        });

        this.preInPortData = R.clone(preInPortDataClone);
        this.inPortData = R.clone(preInPortDataClone);
      } else {
        const connectPortInfo = canConnectOutPortsList.find(
          (item) => item.portId === portId
        );
        const linkId = elementDataMethods.changeInPortConnect(
          connectPortInfo,
          inPortInfoItem
        );
        const inPortDataClone = R.clone(inPortData);
        inPortDataClone[index].sourceCellId = connectPortInfo.cellId;
        inPortDataClone[index].sourcePortId = connectPortInfo.portId;
        inPortDataClone[index].linkId = linkId;

        this.preInPortData = R.clone(inPortDataClone);
        this.inPortData = R.clone(inPortDataClone);
      }
    },
    changeOutPortConnect(portId, outPortInfoItem, index) {
      const {
        canConnectInPortsList,
        elementDataMethods,
        outPortData,
        preOutPortData,
      } = this;

      let isOtherPortConnected = false;
      let conncetedOutPortInfoItem = null;
      let conncetedOutPortInfoItemIndex = null;

      for (let i = 0; i < preOutPortData.length; i++) {
        let tmpOutPortInfoItem = preOutPortData[i];
        if (tmpOutPortInfoItem.targetPortId === portId) {
          isOtherPortConnected = true;
          conncetedOutPortInfoItem = tmpOutPortInfoItem;
          conncetedOutPortInfoItemIndex = i;
          break;
        }
      }

      if (isOtherPortConnected) {
        elementDataMethods.swapInPortsLink(
          preOutPortData[index],
          conncetedOutPortInfoItem
        );
        const preOutPortDataClone = R.clone(preOutPortData);
        // const outPortInfoItemClone = R.clone(preOutPortData[index]);
        const conncetedOutPortInfoItemClone = R.clone(conncetedOutPortInfoItem);

        ["targetPortId", "targetCellId", "linkId"].map((key) => {
          preOutPortDataClone[index][key] = conncetedOutPortInfoItemClone[key];
          preOutPortDataClone[conncetedOutPortInfoItemIndex][key] =
            preOutPortData[index][key];
        });

        this.preOutPortData = R.clone(preOutPortDataClone);
        this.outPortData = R.clone(preOutPortDataClone);
      } else {
        const connectPortInfo = canConnectInPortsList.find(
          (item) => item.portId === portId
        );
        const linkId = elementDataMethods.changeOutPortConnect(
          connectPortInfo,
          outPortInfoItem
        );
        const outPortDataClone = R.clone(outPortData);
        outPortDataClone[index].targetCellId = connectPortInfo.cellId;
        outPortDataClone[index].targetPortId = connectPortInfo.portId;
        outPortDataClone[index].linkId = linkId;

        this.preOutPortData = R.clone(outPortDataClone);
        this.outPortData = R.clone(outPortDataClone);
      }
    },
    addInData() {
      const inPortDataClone = R.clone(this.inPortData);
      inPortDataClone.push(this.elementDataMethods.createInData());
      this.inPortData = inPortDataClone;
    },
    addOutData() {
      const outPortDataClone = R.clone(this.outPortData);
      outPortDataClone.push(this.elementDataMethods.createOutData());
      this.outPortData = outPortDataClone;
    },
    removeInPortInfo(index) {
      const { inPortData, elementDataMethods } = this;
      let inPortDataClone = R.clone(inPortData);
      if (inPortDataClone.length > 1) {
        inPortDataClone = R.remove(index, 1, inPortDataClone);
        elementDataMethods.removeInLink(inPortData[index]);
        elementDataMethods.removeInPort(inPortData[index].targetPortId);
      } else {
        const tmp = R.clone(inPortDataClone[0]);
        if (inPortDataClone[0].linkId) {
          elementDataMethods.removeInLink(inPortDataClone[0]);
        }
        tmp.sourcePortId = "";
        tmp.sourceCellId = "";
        tmp.linkId = "";
        inPortDataClone[0] = tmp;
      }
      this.preInPortData = R.clone(inPortDataClone);
      this.inPortData = R.clone(inPortDataClone);
    },
    removeInPortLink(index) {
      const { inPortData, elementDataMethods } = this;
      let inPortDataClone = R.clone(inPortData);
      if (inPortDataClone.length > 1) {
        // inPortDataClone = R.remove(index, 1, inPortDataClone);
        inPortDataClone[index].sourcePortId = "";
        inPortDataClone[index].sourceCellId = "";
        inPortDataClone[index].linkId = "";

        elementDataMethods.removeInLink(inPortData[index]);
      } else {
        const tmp = R.clone(inPortDataClone[0]);
        if (inPortDataClone[0].linkId) {
          elementDataMethods.removeInLink(inPortDataClone[0]);
        }
        tmp.sourcePortId = "";
        tmp.sourceCellId = "";
        tmp.linkId = "";
        inPortDataClone[0] = tmp;
      }

      this.preInPortData = R.clone(inPortDataClone);
      this.inPortData = R.clone(inPortDataClone);
    },
    removeOutPortInfo(index) {
      const { outPortData, elementDataMethods } = this;
      let outPortDataClone = R.clone(outPortData);
      if (outPortDataClone.length > 1) {
        outPortDataClone = R.remove(index, 1, outPortDataClone);
        elementDataMethods.removeOutLink(outPortData[index]);
      } else {
        const tmp = R.clone(outPortDataClone[0]);
        if (outPortDataClone[0].linkId) {
          elementDataMethods.removeOutLink(outPortDataClone[0]);
        }
        tmp.targetPortId = "";
        tmp.targetCellId = "";
        tmp.linkId = "";
        outPortDataClone[0] = tmp;
      }
      this.preOutPortData = R.clone(outPortDataClone);
      this.outPortData = R.clone(outPortDataClone);
    },
  },
  watch: {
    elementView: {
      handler() {
        // if (!R.equals(newValue.elementName, oldValue.elementName)) {
        //   this.elementName = newValue.elementName;
        // }
        this.init();
      },
      // deep: true,
    },
  },
});
</script>
